// extracted by mini-css-extract-plugin
export default {"sale":"AOZVZ"};